import React, { useEffect } from "react";
import { connect } from "react-redux";
import { navigationActions } from "../../store/actions/navigation/navigation";
import { compose } from "../../utils/compose";
import { makeStyles, Grid } from "@material-ui/core";
import SubscriptionStatus from "../../components/Subscription/SubscriptionStatus";
import BillingInformationSummary from '../../components/BillingInformation/BillingInformationSummary';
import PaymentMethodSummary from '../../components/PaymentMethod/PaymentMethodSummary';
import InvoicesSummary from "../../components/Invoice/InvoicesSummary";

const useStyles = makeStyles(theme => ({
  mainContent: {
    flex: 1,
    padding: "46px 36px 0"
  },
  subCard: {},
  actionMore: {
    marginLeft: "auto"
  }
}));

const BillingStatus = props => {
  const {
    setTitle,
    history,
  } = props;
  const classes = useStyles();

  useEffect(() => {
    setTitle("accountPageTitle");
  }, [setTitle]);

  const editBillingInfoHandler = () => {
    console.log('edit billing info');
    history.push(`/billinginfo`);
  }

  const addPaymentMethodHandler = () => {
    console.log('add payment method');
    history.push('/addpaymentmethod');
  }

  return (
    <main className={classes.mainContent}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SubscriptionStatus />
        </Grid>
        <Grid item xs={12} md={6}>
          <BillingInformationSummary onEdit={editBillingInfoHandler} />
        </Grid>
        <Grid item xs={12} md={6}>
          <PaymentMethodSummary onAdd={addPaymentMethodHandler}/>
        </Grid>
        <Grid item xs={12}>
            <InvoicesSummary />
        </Grid>
      </Grid>

    </main>
  );
};

const mapStateToProps = state => ({
  access_token: state.oidc.user.access_token,
});

const mapDispatchToProps = dispatch => ({
  setTitle: title => dispatch(navigationActions.setTitle(title)),
});

const composed = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(BillingStatus);

export default composed;
